import React from 'react';
import { helpers } from '@simplybenefits/sb-utils';
import { styled } from '@mui/system';
import Grid from "@mui/material/Grid";
import { colors } from '../../../../theme/index.js';
import { DividerLine } from '../../../../components/DividerLine.js';
import { HeaderBar } from '../../../../components/HeaderBar.js';
import Text from '../../../../components/Text.js';
import Button from '../../../../components/Button.js';
import i18n from '../../../../localization/i18n.js';
import tokens from '../../../../localization/tokens.js';
const Block = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
const Row = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "5px 30px 0 50px"
});
const styles = {
  summaryHeader: {
    paddingTop: "0px",
    paddingRight: "8px",
    paddingBottom: "0px",
    paddingLeft: "0px"
  }
};

/**
 * @param divisionTitle
 * @param invoice
 * @param isCurrent
 * @param account
 * @param loading
 * @param isMasterSite
 * @param isDivisionSummary
 * @param selectedDivisionID
 * @param triggerDivisionRepayment
 * @param overallSummary
 * @param blockMemberDetails
 * @param downloadInvoiceCSV
 * @param downloadInvoice
 * @param downloadPayrollDeductions
 * @returns {JSX.Element}
 * @constructor
 */
const Summary = ({
  divisionTitle,
  invoice,
  isCurrent,
  account,
  loading,
  isMasterSite,
  isDivisionSummary,
  selectedDivisionID,
  triggerDivisionRepayment,
  overallSummary,
  blockMemberDetails,
  downloadInvoiceCSV,
  downloadInvoice,
  downloadPayrollDeductions
}) => {
  const carryForward = overallSummary.totals.carryForward || 0;
  const {
    payment,
    voluntaryTotal = 0
  } = invoice.lastInvoice;
  const paymentReceived = payment - voluntaryTotal;
  return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8,
    sx: styles.summaryHeader
  }, /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true
  }, divisionTitle ? `${divisionTitle} ` : '', i18n.t(tokens.titles.summary)), invoice?.meta?.invoiceNum ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      marginTop: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    customStyle: {
      marginRight: 5
    }
  }, i18n.t(tokens.labels.invoices.invoiceNumber), ":"), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true
  }, invoice.meta.invoiceNum)) : null), !isCurrent && !loading ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "flex-end"
  }, isMasterSite && isDivisionSummary && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: triggerDivisionRepayment,
    transparent: true
  }, i18n.t(tokens.labels.invoices.triggerRepayment))), !blockMemberDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: downloadInvoiceCSV,
    transparent: true
  }, i18n.t(tokens.buttons.downloadCsv))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: () => downloadInvoice(isDivisionSummary, selectedDivisionID)
  }, i18n.t(tokens.buttons.downloadPdf))), !isDivisionSummary && invoice.payrollDeductions.length > 0 && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: () => downloadPayrollDeductions()
  }, i18n.t(tokens.buttons.downloadPayrollDeductions)))))) : !isDivisionSummary && invoice.payrollDeductions.length > 0 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    transparent: true,
    onClick: () => downloadPayrollDeductions()
  }, i18n.t(tokens.buttons.downloadPayrollDeductions)))))), !isDivisionSummary && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderBar, null, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true,
    bold: true,
    color: colors.surface
  }, i18n.t(tokens.labels.invoices.previousMonthPremiumDue))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.premiumDueLastMonth)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(invoice.lastInvoice.total, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.paymentReceived)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(paymentReceived, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.carryForwardBalance)), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, helpers.formatNumber(carryForward, 2, true)))), /*#__PURE__*/React.createElement(HeaderBar, null, /*#__PURE__*/React.createElement(Text, {
    mediumLarge: true,
    bold: true,
    color: colors.surface
  }, i18n.t(tokens.labels.invoices.currentMonthPremiumDue))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.adjustmentsForPriorPeriod)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.totals.adjustments instanceof Object ? overallSummary.totals.adjustments.net : overallSummary.totals.adjustments, 2, true))), Boolean(account.isAsoHealth === 1 || account.isAsoDental) && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.asoBalanceAdjustment)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.totals.asoAdjustments || 0, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.miscPremiums)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.miscPremiums.premium, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.optionalBenefits)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.optionalBenefits.premium, 2, true))), overallSummary.specialityProducts !== undefined && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.specialityProducts)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.specialityProducts.premium, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.totalPremiumForPeriod)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.totals.premium, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.carryForward)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(carryForward, 2, true))), Boolean(overallSummary.totals.spendingAccountFloatCharge && overallSummary.totals.spendingAccountFloatCharge !== 0) && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, "Spending Account Float"), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.totals.spendingAccountFloatCharge, 2, true))), Boolean(overallSummary.totals.asoArrearsFloatCharge && overallSummary.totals.asoArrearsFloatCharge !== 0) && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    small: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.asoFloat)), /*#__PURE__*/React.createElement(Text, null, helpers.formatNumber(overallSummary.totals.asoArrearsFloatCharge, 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.subtotal)), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, helpers.formatNumber(carryForward + overallSummary.totals.premium + (overallSummary.totals.adjustments instanceof Object ? overallSummary.totals.adjustments.net : overallSummary.totals.adjustments) + (overallSummary.totals.asoAdjustments || 0) + (overallSummary.totals.spendingAccountFloatCharge || 0) + (overallSummary.totals.asoArrearsFloatCharge || 0), 2, true))), /*#__PURE__*/React.createElement(DividerLine, null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.pst)), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, helpers.formatNumber(overallSummary.totals.PST + (overallSummary.totals.RST || 0), 2, true))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.gstHst)), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, helpers.formatNumber((overallSummary.totals.HST || 0) + (overallSummary.totals.GST || 0), 2, true))), overallSummary.totals.CCFee ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.convenienceFee)), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, helpers.formatNumber(overallSummary.totals.CCFee, 2, true))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Text, {
    large: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, i18n.t(tokens.labels.invoices.totalDue)), /*#__PURE__*/React.createElement(Text, {
    large: true,
    bold: true
  }, helpers.formatNumber(overallSummary.totals.grandTotal, 2, true))), /*#__PURE__*/React.createElement(Text, {
    small: true,
    bold: true,
    margin: "30px 0"
  }, i18n.t(tokens.labels.invoices.carryForwardAmountDue)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    margin: "0 0 20px 0"
  }, i18n.t(tokens.labels.invoices.processingYourPayment)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, i18n.t(tokens.labels.invoices.summaryBreakdown)));
};
export default Summary;